<script lang="ts">
  import { openInNewTab } from '../lib/openInNewTab';

  export let id: string;
  export let text: string;
</script>

<aside>
  <footer>
    <button on:click={() => openInNewTab(`https://onhighloop.com/feedback/via?ref=${id}`)}
      >{text} Highloop</button
    >
  </footer>
</aside>

<style>
  footer {
    padding: 2px 3px 8px 3px;
  }

  button {
    border: none;
    border-radius: 50px;
    font-size: 12px;
    padding: 4px 8px;
    background: transparent;
    transition: all 0.3s;
    margin: 0px auto;
    display: block;
    color: var(--loop-accent2);
    max-width: 100%;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  button:hover,
  button:focus {
    background: var(--loop-accent1, #efefef);
    color: var(--loop-foreground);
  }
</style>
